// ============================================================================
// LINGALA TRANSLATIONS - CHAPTER 6: Misiona ya Polo
// ============================================================================
// Ba niveaux 66-78 (13 ba niveaux, 39 ba mituna)

export const chapter6Translations = {
  name: "Misiona ya Polo",
  description: "Tii na suka ya mabele...",
  
  spiritualWisdom: {
    principle: "Nsango malamu ezali mpo na bikolo nyonso mpe esengeli kosakola yango na mokili mobimba",
    scripture: "Bokende mpe bosala bikolo nyonso bayekoli (Matai 28:19)",
    application: "Mukristo nyonso abengami kozala motatoli ya Klisto na esika oyo Nzambe atii ye"
  },
  
  levels: {
    66: {
      name: "Mobembo ya liboso ya misiona",
      challenge: "Botya Barnaba na Saulo pembeni mpo na mosala oyo nabengaka bango...",
      easy: {
        question: "Nani alandaki Polo na mobembo na ye ya liboso?",
        options: ["Petro", "Barnaba", "Sila", "Timote"],
        hint: "'Mwana ya malimbisi'",
        funFact: "👥 Barnaba ayambaki Polo nsima ya kotalisi - boyokani ya nzela ya Nzambe!"
      },
      medium: {
        question: "Na engumba nini babimaki mpo na mosala na bango?",
        options: [
          "Yerusalemi",
          "Antioki ya Syrie",
          "Tarso",
          "Damasi"
        ],
        hint: "Lisangá ya liboso ya Bayuda mpe Bapagano basangani",
        funFact: "🚢 Antioki: libongo ya kobima mpo na kosakola mokili ya westi!"
      },
      hard: {
        question: "Nini mobembo oyo ya liboso ezali komonisa na ntina ya stratégie ya misiona?",
        options: [
          "Esengeli kotikala na esika na yo",
          "Nsango malamu ekatisi bamikakatano nyonso ya culture",
          "Kaka Bayuda bakoki kobika",
          "Misiona ezali mosala ya koponela"
        ],
        hint: "Ezali koloba na ntina ya universalité ya message",
        funFact: "🌊 Kokatisa ebale ya Mediterane = kokende mpo na kosakola mokili mobimba!"
      }
    },
    
    67: {
      name: "Na Sipro na Elimas",
      challenge: "Oh yo oyo otonda na lokuta nyonso mpe mayele mabe, mwana ya Satana...",
      easy: {
        question: "Nani munganga ya maji oyo atelemaki liboso ya Polo na Sipro?",
        options: ["Simono", "Elimas", "Apolo", "Alexandre"],
        hint: "Profeta ya lokuta oyo alingaki kopengwisa moyangeli",
        funFact: "🪄 Matata ya liboso ya ntembe ntembe kati ya nsango malamu mpe kindoki!"
      },
      medium: {
        question: "Nini Polo asalaki na Elimas lokola etumbu?",
        options: [
          "Abenganaki ye",
          "Akangaki ye miso mwa ntango",
          "Atikaki ye",
          "Aganganaki na ye"
        ],
        hint: "Kokangama miso mwa mpo na kofungola miso na ye ya molimo",
        funFact: "👁️ Ironie ya Nzambe: oyo azalaki kopumbwisa milimo akomi mokufi miso mwa ntango!"
      },
      hard: {
        question: "Ndenge nini likambo oyo ezali kolakisa nguya ya nsango malamu?",
        options: [
          "Mobulu ezali na ntina",
          "Solo ya Nzambe elongaka lokuta",
          "Esengeli kobunda na banganga ya maji nyonso",
          "Polo azalaki na mposa ya kozongisa mabe"
        ],
        hint: "Ezali koloba na ntina ya bokonzi ya Nzambe liboso ya lokuta",
        funFact: "⚡ Moyangeli andimaki ntango amoni nguya ya Nzambe - demonstration ya malamu!"
      }
    },

    68: {
      name: "Na Antioki ya Pisidie",
      challenge: "Na bino yambo esengeli kolobela liloba ya Nzambe...",
      easy: {
        question: "Epai wapi Polo asakolaki ntango akomaki na engumba?",
        options: [
          "Na esika ya zando",
          "Yambo na sinagoga",
          "Na bandako ya bazwi",
          "Na ba tempelo ya bapagano"
        ],
        hint: "Azalaki ntango nyonso kobanda na bato na ye",
        funFact: "🕍 Stratégie ya misiona: yambo na Bayuda, nsima na bapagano!"
      },
      medium: {
        question: "Ndenge nini Bayuda basalaki eyano na message ya Polo?",
        options: [
          "Nyonso bandimaki",
          "Bakabolamaki: basusu bandimaki, basusu batelemaki",
          "Batikalaki na bokebi te",
          "Babenganaki ye mbala moko"
        ],
        hint: "Division classique liboso ya nsango malamu",
        funFact: "⚖️ Nsango malamu ekabolaka ntango nyonso: bondimi to boboya, bokebi te te!"
      },
      hard: {
        question: "Mpo na nini Polo abalelaki bapagano?",
        options: [
          "Alingaki mingi bapagano",
          "Boboyeli ya Bayuda efungoli nzela na bikolo",
          "Ezalaki pete",
          "Atikaki mosala na ye"
        ],
        hint: "Ezali kokokisama ya prophétie",
        funFact: "🚪 'Pole mpo na bikolo' - prophétie ya Esaie ekokisamaki na nzela ya Polo!"
      }
    },

    69: {
      name: "Kobikisa na Lystra",
      challenge: "Banzambe na lolenge ya bato bakiti epai na biso!",
      easy: {
        question: "Nani Polo abikisaki na Lystra?",
        options: [
          "Mokufi miso",
          "Mobeba makolo banda mbotama",
          "Mokufi matoyi-molobi te",
          "Mobela ngenge"
        ],
        hint: "Moto oyo atambolaki naino te",
        funFact: "🦵 Likambo ya kokamwa: 'Telema kosemba na makolo na yo!' - kondima obikisaka!"
      },
      medium: {
        question: "Na nani bato bamilobelaki Polo mpe Barnaba?",
        options: [
          "Bakonzi",
          "Banzambe (Zeus mpe Hermes)",
          "Banganga ya maji",
          "Ba profeta"
        ],
        hint: "Banzambe ya panthéon ya Grèce",
        funFact: "⚡ Barnaba = Zeus (ya kokamwa), Polo = Hermes (molobi) - malengi ya culture!"
      },
      hard: {
        question: "Ndenge nini Polo asalaki eyano na kogumbama oyo ya lokuta?",
        options: [
          "Andimaki lokumu",
          "Apasoli bilamba na ye mpe asakolaki Nzambe ya solo",
          "Akangaki monoko na ye mpo na politesse",
          "Asalelaki likambo yango"
        ],
        hint: "Boboyeli ya mobimba ya kogumbama lokuta",
        funFact: "👔 Kopasola bilamba = somo ya Bayuda liboso ya kogumbama lokuta - bosembo mobimba!"
      }
    },

    70: {
      name: "Kobwaka mabanga mpe kosekwa lisusu",
      challenge: "Ntango bayekoli bazingelaki ye, alamuki mpe akotaki na engumba...",
      easy: {
        question: "Nini bato ya Lystra basalaki na Polo?",
        options: [
          "Bakangaki ye",
          "Babwakaki ye mabanga",
          "Babenganaki ye",
          "Babakaki ye na nzete",
        ],
        hint: "Etumbu ya bonkoko ya Bayuda",
        funFact: "🪨 'Banzambe' na 'mokufi' na mokolo moko - incohérence ya bato!"
      },
      medium: {
        question: "Nini Polo asalaki nsima ya kobwakama mabanga?",
        options: [
          "Akimaki na engumba",
          "Amibombaki",
          "Alamuki mpe azongaki na engumba",
          "Akendaki na lopitalo"
        ],
        hint: "Mpiko ya likolo ya bomoto nsima ya liwa ya kokanisa",
        funFact: "💪 Kosekwa lisusu ya kokamwa to kobikisama ya Nzambe - mpiko ya kokamwa!"
      },
      hard: {
        question: "Nini konyokolama oyo ezali komonisa na ntina ya ntalo ya kotatola?",
        options: [
          "Esengeli koboya matata",
          "Kotatola mpo na Klisto ekoki kozwa bomoi",
          "Polo azalaki na keleli te",
          "Konyokolama ezali na litomba te"
        ],
        hint: "Ezali koloba na ntina ya ntalo ya kotatola ya solo",
        funFact: "✝️ 'Na matata mingi esengeli kokota' - réalisme ya Polo!"
      }
    },

    71: {
      name: "Conseil ya Yerusalemi",
      challenge: "Soki bokatami ngenga te, bokoki kobika te...",
      easy: {
        question: "Nani matata ya ntina esalemaki na Conseil ya Yerusalemi?",
        options: [
          "Baptême",
          "Kokata ngenga ya bapagano oyo babongolaki motema",
          "Mokolo ya sabato",
          "Ba contributions"
        ],
        hint: "Ezali esengeli kokoma Moyuda mpo na kozala mukristo?",
        funFact: "✂️ Crise ya liboso ya monene: christianisme to judaïsme-christianisme?"
      },
      medium: {
        question: "Nini décision finale ya conseil?",
        options: [
          "Kokata ngenga esengeli",
          "Bonsomi mpo na bapagano na ba conseils moke",
          "Séparation mobimba na Bayuda",
          "Boboyeli ya décision"
        ],
        hint: "Bofungoli na bapagano na kondima kaka",
        funFact: "🆓 Révolution ya histoire: nsango malamu elongwi na mibeko ya Moïse!"
      },
      hard: {
        question: "Nini ntina ya conseil oyo mpo na Eglise universelle?",
        options: [
          "Likambo ya moke",
          "Etie moboko ya universalité ya lobiko na kondima kaka",
          "Ekabolaki Eglise",
          "Elendisaki legalisme"
        ],
        hint: "Ezali koloba na ntina ya moboko ya Eglise universelle",
        funFact: "🌍 Na décision oyo te, christianisme elingaki kotikala ekóló ya Bayuda!"
      }
    },

    72: {
      name: "Mobembo ya mibale: Timote",
      challenge: "Polo alingaki komeme ye na ye mpe akataki ye ngenga mpo na Bayuda...",
      easy: {
        question: "Nani ayaki kozala mosalisi ya elenge na Polo?",
        options: ["Marc", "Luc", "Timote", "Tite"],
        hint: "'Mwana oyo alingami' ya Polo",
        funFact: "👦 Timote: elenge prodige oyo akómaki loboko ya mobali ya Polo - formation ya malamu!"
      },
      medium: {
        question: "Mpo na nini Polo akataki Timote ngenga atako bonsomi oyo ezwamaki?",
        options: [
          "Na obligation légale",
          "Na stratégie missionnaire kati ya Bayuda",
          "Na bonkóko",
          "Na mabele"
        ],
        hint: "Bwanya ya praktiki mpo na koboya ba obstacles",
        funFact: "🎯 Bonsomi na bwanya: 'Kokóma nyonso mpo na bato nyonso mpo na kobikisa basusu'!"
      },
      hard: {
        question: "Ndenge nini position oyo ezali kolakisa flexibilité missionnaire?",
        options: [
          "Polo azalaki incohérent",
          "Abongisaki méthode na ye na kozala na compromis te na nsango",
          "Akweyaki na pression",
          "Azalaki hypocrite"
        ],
        hint: "Ezali koloba na ntina ya sagesse contextuelle",
        funFact: "⚖️ Ba principes solides, ba méthodes flexibles - art ya kotatola ya malamu!"
      }
    },

    73: {
      name: "Vision ya moto ya Macédoine",
      challenge: "Katisa na Macédoine mpe bosenga biso!",
      easy: {
        question: "Nini Polo amonaki na vision na ye ya butu?",
        options: [
          "Anzelu",
          "Moto ya Macédoine azali kobenga ye",
          "Yesu azali koloba na ye",
          "Pole monene"
        ],
        hint: "Kobengama mpo na lisalisi kowuta na Europe",
        funFact: "🌉 Vision ya kokamwa: nsango malamu ekatisi na Europe - point ya kotalisa ya histoire!"
      },
      medium: {
        question: "Nini engumba ya liboso ya Europe oyo esakolamaki?",
        options: [
          "Athènes",
          "Corinthe",
          "Philippes",
          "Thessalonique"
        ],
        hint: "Colonie romaine na Macédoine",
        funFact: "🏛️ Philippes: communauté ya liboso ya Europe - mabele ebongwani mpo na libela!"
      },
      hard: {
        question: "Nini vision oyo ezali kosymbola mpo na histoire ya christianisme?",
        options: [
          "Ndoto ya bobele",
          "Expansion providentielle na westi",
          "Hallucination",
          "Changement ya plan"
        ],
        hint: "Ezali koloba na ntina ya providence oyo ezali kotambwisa histoire",
        funFact: "🗺️ Na vision oyo te, Europe elingaki kotikala paganisme - plan ya Nzambe!"
      }
    },

    74: {
      name: "Lydie, mukristo ya liboso ya Europe",
      challenge: "Nkolo afungolaki motema ya Lydie mpo na koyoka...",
      easy: {
        question: "Nini mosala ya Lydie ezalaki?",
        options: [
          "Molamboli mapa",
          "Moteki bilamba ya motane",
          "Motoni bilamba",
          "Mosaleli mbeki"
        ],
        hint: "Commerce ya luxe ya ntango yango",
        funFact: "🟣 Motane = langi ya bokonzi ya talo mingi - Lydie azalaki mozwi!"
      },
      medium: {
        question: "Epai wapi Polo akutanaki na Lydie?",
        options: [
          "Na zando",
          "Na ebale na ntango ya losambo",
          "Na ndako na ye",
          "Na sinagoga"
        ],
        hint: "Esika ya losambo na libanda",
        funFact: "🏞️ Ezalaki na sinagoga te na Philippes - losambo pembeni ya mayi na bonkóko!"
      },
      hard: {
        question: "Nini bobongoli motema ya Lydie ezali komonisa na ntina ya mosala ya Nzambe?",
        options: [
          "Azalaki pene",
          "Nzambe afungolaka mitema oyo ezali pene ya koyamba liloba na ye",
          "Ezalaki hasard",
          "Polo azalaki persuasif"
        ],
        hint: "Ezali koloba na ntina ya action ya Nzambe na conversion",
        funFact: "💝 'Nkolo afungoli motema na ye' - Nzambe azali kobongisa mpe kofungola milimo!"
      }
    },

    75: {
      name: "Boloko na Philippes",
      challenge: "Na kati-butu Polo na Sila basambaki mpe bayembaki nzembo ya lokumu na Nzambe...",
      easy: {
        question: "Mpo na nini Polo na Sila bakangamaki?",
        options: [
          "Koyiba",
          "Matata ya zando na kobengana molimo mabe",
          "Blasphème",
          "Rebellion"
        ],
        hint: "Kobikisa mwasi mosali oyo azalaki koloba makambo",
        funFact: "💸 Kokangola molimo ezwaka ntalo monene mpo na ba exploiteurs - konyokola économique!"
      },
      medium: {
        question: "Nini Polo na Sila basalaki na boloko?",
        options: [
          "Bamilelaki",
          "Basambaki mpe bayembaki",
          "Babongisaki défense na bango",
          "Balalaki"
        ],
        hint: "Lokumu atako ba chaînes",
        funFact: "🎵 Nzembo ya lokumu na kati-butu na boloko - kondima ya kokamwa oyo ezali kolendisa!"
      },
      hard: {
        question: "Ndenge nini bizaleli na bango ebongolaki likambo?",
        options: [
          "Ezalaki na effet te",
          "Ebongolaki mokengeli nsima ya tremblement ya mabele",
          "Esalaki bakengeli bazala na nkanda",
          "Epesaki bango liboso ya mabele"
        ],
        hint: "Kotatola ya makasi na ndakisa",
        funFact: "🌍 Tremblement ya mabele + kotatola = conversion ya mokengeli mpe libota na ye!"
      }
    },

    76: {
      name: "Na Athènes: Aréopage",
      challenge: "Oyo bozali kogumbama na boyebi te, yango nazali kosakola bino...",
      easy: {
        question: "Na altar nini Polo asalelaki na Athènes?",
        options: [
          "Na nzambe Zeus",
          "Na nzambe oyo ayebani te",
          "Na Apollon",
          "Na Athéna"
        ],
        hint: "Inscription mystérieuse oyo esalelaki lokola point ya départ",
        funFact: "🏛️ 'Na nzambe oyo ayebani te' - point ya contact ya mayele na philosophie ya Grèce!"
      },
      medium: {
        question: "Liboso ya nani Polo asakolaki na Athènes?",
        options: [
          "Bato ya pamba",
          "Ba philosophes épicuriens na stoïciens na Aréopage",
          "Ba prêtres ya ba tempelo",
          "Empereur romain"
        ],
        hint: "Elite intellectuelle ya Grèce",
        funFact: "🧠 Aréopage = Harvard ya kala - Polo liboso ya ba penseurs ya minene!"
      },
      hard: {
        question: "Nini eyano ya ba Athéniens na résurrection ezalaki?",
        options: [
          "Bondimi ya mobimba",
          "Division: batioli, basusu bazalaki na intérêt",
          "Kanda ya mobimba",
          "Indifférence mobimba"
        ],
        hint: "Réaction typique ya ba intellectuels na mystère oyo",
        funFact: "🤔 Résurrection = pierre ya bondimi mpo na intelligence ya bato oyo ezali na lofundu!"
      }
    },

    77: {
      name: "Corinthe: Polo mosali ba tentes",
      challenge: "Atikalaki na bango mpe asalaki, mpo na mosala na bango bazalaki basali ba tentes...",
      easy: {
        question: "Na mosala nini Polo asalaki mpo na kozwa mbongo?",
        options: [
          "Mokangi mbisi",
          "Mosali ba tentes",
          "Mokomi",
          "Moteki"
        ],
        hint: "Mosala ya maboko oyo ayekolaki",
        funFact: "⛺ Polo: apôtre-artisan - lokumu ya mosala ya maboko kati ya bakristo!"
      },
      medium: {
        question: "Epai ya nani Polo afandaki na Corinthe?",
        options: [
          "Na auberge",
          "Epai ya Aquilas na Priscille",
          "Epai ya gouverneur",
          "Na sinagoga"
        ],
        hint: "Couple ya basali ba tentes lokola ye",
        funFact: "👫 Aquilas na Priscille: couple missionnaire ya modèle - hospitalité ya bakristo!"
      },
      hard: {
        question: "Mpo na nini Polo asalaki na maboko na ye?",
        options: [
          "Kaka mpo na nécessité économique",
          "Mpo na kozala mokilo te mpe kolendisa kotatola na ye",
          "Na bonkóko ya libota",
          "Mpo alingaki mosala yango"
        ],
        hint: "Ezali koloba na ntina ya indépendance mpe crédibilité",
        funFact: "💼 Indépendance économique = bonsomi ya koloba - Polo azalaki na boyokani na moto te!"
      }
    },

    78: {
      name: "Matata na Ephèse",
      challenge: "Monene Artémis ya ba Ephésiens!",
      easy: {
        question: "Nani atombolaki matata liboso ya Polo na Ephèse?",
        options: [
          "Ba autorités romaines",
          "Démétrius orfèvre na basali",
          "Ba philosophes",
          "Ba prêtres ya Bayuda"
        ],
        hint: "Baoyo basalaki ba temples ya Artémis",
        funFact: "🏛️ Grève ya liboso ya histoire: nsango malamu ezali kotyola économie ya banzambe ya lokuta!"
      },
      medium: {
        question: "Ntango boni Polo ateyaki na Ephèse?",
        options: [
          "6 basanza",
          "1 mobu",
          "2 bamobu",
          "3 bamobu"
        ],
        hint: "Séjour missionnaire ya molai mingi ya ye",
        funFact: "📅 3 bamobu ya enseignement intense - Ephèse ekómaki centre missionnaire ya ntina!"
      },
      hard: {
        question: "Nini matata oyo ezali komonisa na ntina ya impact social ya nsango malamu?",
        options: [
          "Nsango malamu ebongolaka eloko te",
          "Ebongolaka ba structures économiques mpe sociales",
          "Etandaka kaka na religion",
          "Eboyaka matata"
        ],
        hint: "Ezali koloba na ntina ya changement social ya mozindo",
        funFact: "💰 Ntango nsango malamu ezali kokende liboso, banzambe ya lokuta babungisaka marché - impact économique!"
      }
    }
  }
};

export default chapter6Translations;
